// extracted by mini-css-extract-plugin
module.exports = {"main":"Post_main__1mWbC","icons":"Post_icons__33ofv","hover":"Post_hover__-1zng"};